import React from "react";

import { Dropdown } from "~/components/dropdown";
import { IconEllipsisOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";

import { useClosestRelativeContainer } from "../RelativeContainer";

import styles from "./_ctx-popover-menu.module.css";
import { CtxMenu } from "./CtxMenu";

export const CtxPopoverMenu: React.FC<
	React.PropsWithChildren<{
		icon?: React.ReactNode;
		ellipsisClassName?: string;
		zIndex?: number;
		className?: string;
	}>
> = ({ children, icon, ellipsisClassName, zIndex, ...restProps }) => {
	const container = useClosestRelativeContainer();
	const fallbackZIndex = container ? 10 : undefined;

	return (
		<div
			className="contents"
			onClick={(event) => {
				event.preventDefault();
				event.stopPropagation();
			}}
		>
			<Dropdown
				className="hover:text-primary-500 focus-visible:text-primary-600"
				getPopupContainer={() => container ?? document.body}
				overlay={
					<CtxMenu data-testid="ctx-popover-menu" {...restProps}>
						{children}
					</CtxMenu>
				}
				overlayStyle={{ zIndex: zIndex ?? fallbackZIndex }}
				placement="bottomRight"
				trigger={["click"]}
			>
				<button type="button">
					{icon ? (
						icon
					) : (
						<IconEllipsisOutlined
							className={cx(styles.contextPopoverMenuEllipsis, ellipsisClassName)}
							data-testid="ctx-popover-menu-toggler"
						/>
					)}
				</button>
			</Dropdown>
		</div>
	);
};
